import React from 'react';
import { Link, Image } from './common/NextAdapters';
import { Icon } from '@iconify/react';

/**
 * The top of an interior page. The site header is transparent until the page
 * scrolls, so this band runs to the top of the window and carries its own top
 * padding to clear it.
 *
 * `art` is optional. Where a page has a colour of its own — a genre keeps one
 * from the home grid onwards — it comes in here and the band is built from it,
 * so the page you land on looks like the tile you clicked.
 */
export function PageMasthead({ title, lead, meta, back, art, children }) {
  return (
    <header className="relative isolate overflow-hidden -mt-16">
      {art ? (
        <>
          <div className="absolute inset-0" style={{ backgroundImage: art.gradient }} />
          {art.image ? (
            <Image
              src={art.image}
              alt=""
              fill
              priority
              sizes="100vw"
              className="object-cover opacity-35"
            />
          ) : null}
          <div className="absolute inset-0 bg-background/55" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent" />
        </>
      ) : null}

      <div
        className={
          art
            ? 'relative mx-auto max-w-[1600px] gutter pt-28 pb-10 sm:pt-36 sm:pb-14'
            : 'relative mx-auto max-w-[1600px] gutter pt-24 pb-6 sm:pt-32 sm:pb-8'
        }
      >
        {back ? (
          <Link
            href={back.href}
            className="group/back inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none"
          >
            <Icon
              icon="ph:arrow-left-bold"
              className="size-3.5 transition-transform duration-200 group-hover/back:-translate-x-0.5"
            />
            {back.label}
          </Link>
        ) : null}

        <h1
          className={
            back
              ? 'display mt-3 text-[clamp(2.25rem,6vw,4.25rem)] text-balance font-extrabold text-foreground'
              : 'display text-[clamp(2.25rem,6vw,4.25rem)] text-balance font-extrabold text-foreground'
          }
        >
          {title}
        </h1>

        {lead ? (
          <p className="mt-3 max-w-[54ch] text-base leading-relaxed text-foreground/75">
            {lead}
          </p>
        ) : null}

        {meta ? <div className="mt-4">{meta}</div> : null}
        {children}
      </div>
    </header>
  );
}

export default PageMasthead;
